<template>
    <div id="content">
        <div class="container">
            <div class="contact-form">
                <h2 class="contact-form-title">{{ $t('contact_form.title') }}</h2>
                <div class="contact-form-description">{{ $t('contact_form.description') }}</div>
                <b-form @submit.prevent="onSubmit">
                    <div class="form-group text-left">
                        <b-form-input v-model="form.name" type="text"
                                      :placeholder="$t('contact_form.full_name')"
                                      :state="validation.name.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.name.valid">
                            {{ validation.name.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group text-left">
                        <b-form-input v-model="form.email" type="email"
                                      :placeholder="$t('contact_form.email')"
                                      :state="validation.email.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.email.valid">
                            {{ validation.email.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group text-left">
                        <b-form-textarea v-model="form.message" rows="5"
                                      :placeholder="$t('contact_form.message')"
                                      :state="validation.message.valid"
                                      required></b-form-textarea>
                        <b-form-invalid-feedback :state="validation.message.valid">
                            {{ validation.message.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <button type="submit" class="btn btn-success btn-icon-right mt-3">
                        {{ $t('contact_form.send') }}
                        <span class="material-icon icon-send"></span>
                    </button>
                </b-form>
            </div>
        </div>
        <powered-by v-if="hasPoweredBy"/>
    </div>
</template>

<style lang="scss" scoped>
    .contact-form {
        width: 100%;
        max-width: 625px;
        margin: 0 auto;
        padding: 50px 115px 60px;
        background-color: var(--bg-color);
        text-align: center;

        &-title {
            font-size: 2rem;
            margin-bottom: 15px;
        }

        &-description {
            font-size: .78rem;
            margin-bottom: 35px;
        }
    }

    [type="submit"] .material-icon {
        font-size: 1.25rem !important;
    }

    body.-is-mobile .contact-form {
        padding: 30px 20px;
    }
</style>

<script>
  import PoweredBy from '../components/PoweredBy.vue';

  import contact from 'src/mixins/contactPage';

  export default {
    mixins: [contact],
    components: {
      PoweredBy,
    },
  };
</script>